/*
  FlaregunTV favorites — localStorage wishlist (per country).

  Injects:
  - A heart button on every product card on collection / list pages
  - A heart button at the top-right of the product info on Iraq product pages
  - A modal on first add ("Add to Wishlist", explaining what happened)
  - Updates the header heart-icon count badge

  All favorites are stored per-country in localStorage (fg-fav-iraq, fg-fav-lebanon, etc.).
*/
(function () {
  'use strict';

  // Every country with a wishlist page. GCC joined 2026-08-16 (owner) — before
  // that activeCountry() could not resolve qa/bh/kw/om, so the heart buttons never
  // rendered on those stores at all.
  var COUNTRIES = ['iraq', 'lebanon', 'jordan', 'egypt', 'uae', 'qatar', 'bahrain', 'kuwait', 'oman'];

  // Copy + wishlist URL are rendered by theme.liquid (window.fgPage). The URL comes
  // from fg-country-config field 16, so it is right for the country being viewed and
  // carries the /ar prefix. It is BLANK for countries with no wishlist page — the
  // modal then drops the "View Wishlist" button rather than link to a 404. The old
  // hardcoded /pages/<country>-favorites map 404'd everywhere but iraq/lebanon.
  var EN = {
    addTitle: 'Added to Wishlist',
    addBody: 'You can find this product anytime by tapping the heart icon in the header.',
    removeTitle: 'Removed from Wishlist',
    removeBody: 'You can re-add this product anytime by tapping the heart icon again.',
    view: 'View Wishlist', keep: 'Keep Browsing', close: 'Close',
    addFav: 'Add to favorites', removeFav: 'Remove from favorites',
    addBrand: 'Save brand to favorites', removeBrand: 'Remove brand from favorites',
    brandAdded: 'Added to favourites', brandRemoved: 'Removed from favourites'
  };
  function t(key) {
    var s = (window.fgPage && window.fgPage.strings) || {};
    return s[key] || EN[key] || '';
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var HEART_OUTLINE_SVG =
    '<svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12 20.5s-7-4.2-9-8.7C1.5 8.5 3.5 5.5 6.8 5.5c1.7 0 3.2 0.9 5.2 3 2-2.1 3.5-3 5.2-3 3.3 0 5.3 3 3.8 6.3-2 4.5-9 8.7-9 8.7z" ' +
            'stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" fill="none" class="fg-heart"/>' +
    '</svg>';

  function storageKey(c) { return 'fg-fav-' + c; }

  function getFavs(c) {
    try { return JSON.parse(localStorage.getItem(storageKey(c))) || []; }
    catch (e) { return []; }
  }

  function setFavs(c, list) {
    try { localStorage.setItem(storageKey(c), JSON.stringify(list)); } catch (e) {}
    updateHeaderCount();
    document.dispatchEvent(new CustomEvent('fg:favs-changed', { detail: { country: c, list: list } }));
  }

  function isFav(c, h) { return getFavs(c).indexOf(h) >= 0; }

  function toggleFav(c, h) {
    var list = getFavs(c);
    var i = list.indexOf(h);
    if (i >= 0) { list.splice(i, 1); } else { list.push(h); }
    setFavs(c, list);
    return i < 0; // true if added
  }

  // ── Brand favorites (separate list, keyed per country) ───────
  // Stored as objects { handle, title, url, image } so the favorites page can
  // render brand cards without an extra fetch.
  function brandKey(c) { return 'fg-fav-brands-' + c; }
  function getBrandFavs(c) {
    try { return JSON.parse(localStorage.getItem(brandKey(c))) || []; }
    catch (e) { return []; }
  }
  function setBrandFavs(c, list) {
    try { localStorage.setItem(brandKey(c), JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('fg:brand-favs-changed', { detail: { country: c, list: list } }));
  }
  function isBrandFav(c, handle) {
    return getBrandFavs(c).some(function (b) { return b.handle === handle; });
  }
  function toggleBrandFav(c, brand) {
    var list = getBrandFavs(c);
    var i = -1;
    for (var k = 0; k < list.length; k++) { if (list[k].handle === brand.handle) { i = k; break; } }
    if (i >= 0) { list.splice(i, 1); } else { list.push(brand); }
    setBrandFavs(c, list);
    return i < 0; // true if added
  }

  // ── Toast ────────────────────────────────────────────────────
  function showToast(text) {
    var HEART = '<svg viewBox="0 0 24 24" width="18" height="18" fill="#fff" aria-hidden="true"><path d="M12 21s-7.5-4.5-9.5-9.5C1 8.5 3 5 6.5 5c2 0 3.5 1 5.5 3 2-2 3.5-3 5.5-3 3.5 0 5.5 3.5 4 6.5C19.5 16.5 12 21 12 21z"/></svg>';
    var existing = document.getElementById('fg-fav-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'fg-fav-toast';
    t.className = 'fg-fav-toast';
    t.innerHTML = HEART + '<span></span>';
    t.querySelector('span').textContent = text;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-shown'); });
    setTimeout(function () {
      t.classList.remove('is-shown');
      setTimeout(function () { t.remove(); }, 240);
    }, 1900);
  }

  // ── Country detection ────────────────────────────────────────
  function detectCountryFromTemplate() {
    var sfx = (window.fgPage && window.fgPage.templateSuffix) || '';
    if (!sfx) return null;
    sfx = sfx.toLowerCase();
    for (var i = 0; i < COUNTRIES.length; i++) {
      if (sfx.indexOf(COUNTRIES[i]) === 0 || sfx.indexOf(COUNTRIES[i] + '-') >= 0) return COUNTRIES[i];
    }
    if (sfx === 'iq-b' || sfx.indexOf('iq-') === 0) return 'iraq';
    if (sfx === 'lb-b' || sfx.indexOf('lb-') === 0) return 'lebanon';
    if (sfx === 'jo-b' || sfx.indexOf('jo-') === 0) return 'jordan';
    if (sfx === 'eg-b' || sfx.indexOf('eg-') === 0) return 'egypt';
    if (sfx === 'qa-b' || sfx.indexOf('qa-') === 0) return 'qatar';
    if (sfx === 'bh-b' || sfx.indexOf('bh-') === 0) return 'bahrain';
    if (sfx === 'kw-b' || sfx.indexOf('kw-') === 0) return 'kuwait';
    if (sfx === 'om-b' || sfx.indexOf('om-') === 0) return 'oman';
    return null;
  }

  function detectCountryFromUrl() {
    var p = (location.pathname || '').toLowerCase();
    if (p.indexOf('iraq') >= 0 || p.indexOf('/iq-') >= 0 || p.indexOf('iq-b') >= 0) return 'iraq';
    if (p.indexOf('lebanon') >= 0 || p.indexOf('/lb-') >= 0) return 'lebanon';
    if (p.indexOf('jordan') >= 0 || p.indexOf('/jo-') >= 0) return 'jordan';
    if (p.indexOf('egypt') >= 0 || p.indexOf('/eg-') >= 0) return 'egypt';
    if (p.indexOf('qatar') >= 0 || p.indexOf('/qa-') >= 0) return 'qatar';
    if (p.indexOf('bahrain') >= 0 || p.indexOf('/bh-') >= 0) return 'bahrain';
    if (p.indexOf('kuwait') >= 0 || p.indexOf('/kw-') >= 0) return 'kuwait';
    if (p.indexOf('oman') >= 0 || p.indexOf('/om-') >= 0) return 'oman';
    return null;
  }

  function activeCountry() {
    var c = detectCountryFromTemplate() || detectCountryFromUrl();
    if (c) return c;
    // Root home ("/") and country-gated pages have no country in the URL/template —
    // fall back to the shopper's selected country from localStorage.
    try {
      var sc = (localStorage.getItem('selectedCountry') || '').toLowerCase();
      var map = { iq: 'iraq', lb: 'lebanon', jo: 'jordan', eg: 'egypt', uae: 'uae',
                  qa: 'qatar', bh: 'bahrain', kw: 'kuwait', om: 'oman' };
      if (map[sc]) return map[sc];
    } catch (e) {}
    return null;
  }

  // ── Header count badge ───────────────────────────────────────
  function updateHeaderCount() {
    var c = activeCountry();
    if (!c) return;
    var el = document.querySelector('[data-fg-fav-count]');
    if (!el) return;
    var count = getFavs(c).length;
    el.textContent = count > 0 ? count : '';
  }

  // ── Modal ────────────────────────────────────────────────────
  // action: 'add' or 'remove'. Each shows at most once per browser session.
  function showFavModal(action) {
    if (document.getElementById('fg-fav-modal')) return;
    var sessionKey = 'fg-fav-modal-shown-' + action;
    try {
      if (sessionStorage.getItem(sessionKey)) return; // already shown this session
      sessionStorage.setItem(sessionKey, '1');
    } catch (e) { /* sessionStorage blocked — still show once per page */ }

    var favUrl = (window.fgPage && window.fgPage.favUrl) || '';

    var content = action === 'remove'
      ? { title: t('removeTitle'), body: t('removeBody') }
      : { title: t('addTitle'),    body: t('addBody') };

    var modal = document.createElement('div');
    modal.id = 'fg-fav-modal';
    modal.className = 'fg-fav-modal';
    modal.innerHTML =
      '<button class="fg-fav-modal__backdrop" data-close aria-label="' + esc(t('close')) + '"></button>' +
      '<div class="fg-fav-modal__card" role="dialog" aria-labelledby="fg-fav-modal-title">' +
        '<button class="fg-fav-modal__close" data-close aria-label="' + esc(t('close')) + '">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
            '<path d="M6 6l12 12M6 18L18 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
        '<h2 id="fg-fav-modal-title">' + esc(content.title) + '</h2>' +
        '<p>' + esc(content.body) + '</p>' +
        '<div class="fg-fav-modal__actions">' +
          '<button class="fg-fav-modal__btn" data-close>' + esc(t('keep')) + '</button>' +
          (favUrl
            ? '<a class="fg-fav-modal__btn fg-fav-modal__btn--primary" href="' + esc(favUrl) + '">' + esc(t('view')) + '</a>'
            : '') +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    function close() {
      modal.classList.remove('fg-fav-modal--open');
      setTimeout(function () { modal.remove(); }, 220);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    modal.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', onKey);

    // Open animation
    requestAnimationFrame(function () { modal.classList.add('fg-fav-modal--open'); });
  }

  // ── Styles ───────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('fg-fav-style')) return;
    var s = document.createElement('style');
    s.id = 'fg-fav-style';
    s.textContent =
      /* ── Heart button: small circular button used on cards + product page top-right ── */
      '.fg-heart-btn{position:absolute;top:10px;right:10px;width:40px;height:40px;border-radius:50%;' +
        'background:rgba(255,255,255,0.9);border:none;color:#000;cursor:pointer;z-index:5;' +
        'display:inline-flex;align-items:center;justify-content:center;padding:0;' +
        'box-shadow:0 1px 3px rgba(0,0,0,0.1);transition:transform 0.18s ease, background 0.18s ease;}' +
      '.fg-heart-btn:hover{background:#ffffff;transform:scale(1.05);}' +
      '.fg-heart-btn:active{transform:scale(0.92);}' +
      '.fg-heart-btn[aria-pressed="true"] .fg-heart{fill:var(--fg-danger);stroke:var(--fg-danger);}' +
      '.fg-heart-btn[aria-pressed="true"]{background:rgba(255,255,255,0.95);}' +
      /* Pop animation on activation */
      '@keyframes fg-heart-pop{0%{transform:scale(1)}40%{transform:scale(1.3)}100%{transform:scale(1)}}' +
      '.fg-heart-btn.fg-heart-pop .fg-heart{animation:fg-heart-pop 0.34s ease;}' +
      /* Variant: dark backdrop heart (for cards on dark backgrounds) */
      '.fg-heart-btn--dark{background:rgba(0,0,0,0.55);color:#fff;}' +
      '.fg-heart-btn--dark:hover{background:rgba(0,0,0,0.8);}' +
      /* Variant: on-image — white circular backdrop so the heart reads on white
         product photos (the old bare-outline version vanished on light images). */
      '.fg-heart-btn--onimage{background:rgba(255,255,255,0.92);color:#1d1d1f;width:38px;height:38px;box-shadow:0 1px 6px rgba(0,0,0,0.3);}' +
      '.fg-heart-btn--onimage:hover{background:#ffffff;transform:scale(1.08);}' +
      '.fg-heart-btn--onimage .fg-heart{stroke:currentColor;stroke-width:1.9;}' +
      '.fg-heart-btn--onimage[aria-pressed="true"] .fg-heart{fill:var(--fg-danger);stroke:var(--fg-danger);}' +
      '.fg-heart-btn--onimage[aria-pressed="true"]{background:rgba(255,255,255,0.95);}' +
      '.fg-heart-btn--dark[aria-pressed="true"]{background:rgba(0,0,0,0.55);}' +
      /* On-image tile hearts: same size + inset as the quick-add plus (38px, 8px)
         so the two read as one aligned column on product tiles. */
      '.fg-heart-btn--onimage{top:8px;right:8px;}' +
      '@media (max-width:749px){' +
        '.fg-heart-btn{width:44px;height:44px;}' +
        '.fg-heart-btn svg{width:22px;height:22px;}' +
        '.fg-heart-btn--onimage{width:38px;height:38px;}' +
        '.fg-heart-btn--onimage svg{width:20px;height:20px;}' +
      '}' +
      /* Lightweight toast (used when saving/removing a brand) */
      '.fg-fav-toast{position:fixed;left:50%;bottom:calc(76px + env(safe-area-inset-bottom,0px));transform:translateX(-50%) translateY(12px);' +
        'z-index:10001;display:flex;align-items:center;gap:10px;max-width:calc(100vw - 32px);' +
        'background:#1d1d1f;color:#fff;padding:12px 18px;border-radius:14px;box-shadow:0 8px 30px rgba(0,0,0,0.28);' +
        'font-size:14px;font-weight:500;opacity:0;transition:opacity .2s ease, transform .2s ease;pointer-events:none;}' +
      '.fg-fav-toast.is-shown{opacity:1;transform:translateX(-50%) translateY(0);}' +
      '.fg-fav-toast svg{flex:0 0 auto;}' +
      '@media (prefers-reduced-motion: reduce){.fg-fav-toast{transition:none;}}' +
      /* Product-page heart at the top-right of the main product info */
      '.fg-heart-btn--product{top:8px;right:16px;background:transparent;box-shadow:none;color:inherit;}' +
      '.fg-heart-btn--product:hover{background:rgba(0,0,0,0.05);}' +
      /* Inline-product variant — sits in the Flaregun Shop block on the right side */
      '.fg-heart-btn--inline-product{position:static;width:38px;height:38px;flex-shrink:0;' +
        'background:transparent;border:1.5px solid currentColor;box-shadow:none;color:inherit;opacity:0.85;}' +
      '.fg-heart-btn--inline-product:hover{opacity:1;background:rgba(0,0,0,0.04);transform:none;}' +
      '.fg-heart-btn--inline-product:active{transform:scale(0.92);}' +
      /* Modal */
      '.fg-fav-modal{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;' +
        'opacity:0;visibility:hidden;transition:opacity 0.22s ease, visibility 0.22s ease;padding:20px;}' +
      '.fg-fav-modal--open{opacity:1;visibility:visible;}' +
      '.fg-fav-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,0.5);border:none;cursor:pointer;}' +
      '.fg-fav-modal__card{position:relative;background:#fff;color:#1d1d1f;border-radius:22px;' +
        'max-width:460px;width:100%;padding:28px 24px 22px;box-shadow:0 16px 60px rgba(0,0,0,0.25);' +
        'transform:translateY(20px) scale(0.96);transition:transform 0.28s cubic-bezier(0.2,0.9,0.3,1);' +
        'font-family:inherit;}' +
      '.fg-fav-modal--open .fg-fav-modal__card{transform:translateY(0) scale(1);}' +
      '.fg-fav-modal__close{position:absolute;top:12px;right:12px;width:32px;height:32px;' +
        'background:transparent;border:none;cursor:pointer;border-radius:50%;color:#1d1d1f;' +
        'display:flex;align-items:center;justify-content:center;}' +
      '.fg-fav-modal__close:hover{background:rgba(0,0,0,0.06);}' +
      '.fg-fav-modal__card h2{margin:0 0 14px;font-size:22px;font-weight:600;text-align:center;letter-spacing:-0.02em;}' +
      '.fg-fav-modal__card p{margin:0 0 22px;font-size:14px;line-height:1.5;color:#3a3a3c;text-align:center;}' +
      '.fg-fav-modal__actions{display:flex;gap:10px;}' +
      '.fg-fav-modal__btn{flex:1;display:inline-flex;align-items:center;justify-content:center;' +
        'padding:14px 18px;border-radius:980px;font-size:15px;font-weight:500;cursor:pointer;' +
        'text-decoration:none;color:#1d1d1f;background:#fff;border:1px solid #1d1d1f;transition:opacity 0.2s ease;}' +
      '.fg-fav-modal__btn--primary{background:#1d1d1f;color:#fff;border-color:#1d1d1f;}' +
      '.fg-fav-modal__btn:hover{opacity:0.88;}' +
      /* Make parent cards relatively positioned so the heart anchors inside */
      '.fg-shelf__item, .card-wrapper, .product-card-wrapper, .grid__item .card, ' +
        '.fg-card-product-host{position:relative;}' +
      '@media (max-width:480px){' +
        '.fg-fav-modal__card{padding:24px 18px 18px;}' +
        '.fg-fav-modal__card h2{font-size:19px;}' +
        '.fg-fav-modal__card p{font-size:13px;}' +
        '.fg-fav-modal__btn{font-size:14px;padding:12px 14px;}' +
      '}';
    document.head.appendChild(s);
  }

  // ── Heart click handler factory ──────────────────────────────
  function makeHeartButton(country, handle, opts) {
    opts = opts || {};
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fg-heart-btn' + (opts.variant ? ' fg-heart-btn--' + opts.variant : '');
    btn.setAttribute('aria-label', isFav(country, handle) ? t('removeFav') : t('addFav'));
    btn.setAttribute('aria-pressed', isFav(country, handle) ? 'true' : 'false');
    btn.dataset.handle = handle;
    btn.innerHTML = HEART_OUTLINE_SVG;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggleFav(country, handle);
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      btn.setAttribute('aria-label', added ? t('removeFav') : t('addFav'));
      // Pop animation
      btn.classList.remove('fg-heart-pop');
      void btn.offsetWidth;
      btn.classList.add('fg-heart-pop');
      // Show modal once per session per action (add/remove)
      showFavModal(added ? 'add' : 'remove');
    });

    return btn;
  }

  // ── Card heart injection (landing / collection / shelves) ──
  function injectCardHearts() {
    var country = activeCountry();
    if (!country) return;

    // Respect admin toggles: landing vs collection
    var tmpl = (window.fgPage && window.fgPage.template) || '';
    var onCollection = tmpl === 'collection';
    var onLandingOrOther = !onCollection && tmpl !== 'product';
    if (onCollection && window.fgPage && window.fgPage.favOnCollection === false) return;
    if (onLandingOrOther && window.fgPage && window.fgPage.favOnLanding === false) return;

    // .fg-catb__tile left the list 2026-09-08: the Categories tab is a category
    // DIRECTORY now (fg-categories-browse), so it renders no product cards at all.
    var CARD_SEL = '.fg-shelf__item, .card-wrapper, .product-card-wrapper, .grid__item, .card-product, .product-card, .fg-coll__card';
    var links = document.querySelectorAll('a[href*="/products/"]');
    var handled = new Set();

    links.forEach(function (link) {
      // Walk up to collect all matching wrappers, then pick the OUTERMOST.
      var wrappers = [];
      var node = link.parentElement;
      while (node && node !== document.body) {
        if (node.matches && node.matches(CARD_SEL)) wrappers.push(node);
        node = node.parentElement;
      }
      if (wrappers.length === 0) return;

      var card = wrappers[wrappers.length - 1]; // outermost
      if (handled.has(card)) return;
      handled.add(card);
      if (card.querySelector('.fg-heart-btn')) return;

      var m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (!m) return;

      // White-circle on-image heart everywhere — reads on any photo (noon style).
      var btn = makeHeartButton(country, m[1], { variant: 'onimage' });
      card.appendChild(btn);
    });
  }

  // ── Product page heart (inline-right of the Flaregun Shop block) ──
  function injectProductHeart() {
    if (!window.fgPage || window.fgPage.template !== 'product') return;
    if (window.fgPage.favOnProduct === false) return;
    var country = activeCountry();
    if (!country) return;
    if (document.querySelector('.fg-heart-btn--inline-product')) return;

    var handle = window.fgPage.handle;
    if (!handle) return;

    // Find the Flaregun Shop caption block — that's where the heart goes (right side)
    var block = document.querySelector('[id*="product_text_J6CJTc"]') ||
                document.querySelector('.shopify-block .product__text.caption-with-letter-spacing') ||
                document.querySelector('.product__text.caption-with-letter-spacing');
    if (!block) return;

    // Turn block into flex row: text left, heart right
    block.style.display = 'flex';
    block.style.alignItems = 'center';
    block.style.justifyContent = 'space-between';
    block.style.gap = '12px';

    var btn = makeHeartButton(country, handle, { variant: 'inline-product' });
    block.appendChild(btn);
  }

  // ── Brand hearts (favourite this brand) ──────────────────────
  // Wires EVERY [data-fg-brand-fav] button — the brand-page header heart and
  // the per-logo hearts on the home "Shop by brand" slider. All hearts for
  // the same brand stay in sync via the brand-favs-changed broadcast.
  function injectBrandHeart() {
    var country = activeCountry();
    if (!country) return;
    document.querySelectorAll('[data-fg-brand-fav]').forEach(function (el) {
      if (el.dataset.fgBound) return;
      var brand = {
        handle: el.dataset.brandHandle || '',
        title:  el.dataset.brandTitle || '',
        url:    el.dataset.brandUrl || '',
        image:  el.dataset.brandImage || ''
      };
      if (!brand.handle) return;
      el.dataset.fgBound = '1';

      function sync() {
        var on = isBrandFav(country, brand.handle);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        el.setAttribute('aria-label', on ? t('removeBrand') : t('addBrand'));
      }
      sync();
      document.addEventListener('fg:brand-favs-changed', sync);

      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var added = toggleBrandFav(country, brand);
        el.classList.remove('fg-heart-pop');
        void el.offsetWidth;
        el.classList.add('fg-heart-pop');
        showToast(added ? t('brandAdded') : t('brandRemoved'));
      });
    });
  }

  // ── Init ─────────────────────────────────────────────────────
  function init() {
    injectStyles();
    updateHeaderCount();
    injectProductHeart();
    injectBrandHeart();
    injectCardHearts();

    // Re-run on async DOM changes (infinite scroll, recommendations loading).
    // Coalesced to one scan per frame — the raw callback fires for every DOM
    // mutation (toasts, cart badge, sliders) and each scan walks all product links.
    var scanQueued = false;
    var mo = new MutationObserver(function () {
      if (scanQueued) return;
      scanQueued = true;
      requestAnimationFrame(function () {
        scanQueued = false;
        injectCardHearts();
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FGFavorites = {
    get: getFavs,
    set: setFavs,
    toggle: toggleFav,
    isFav: isFav,
    activeCountry: activeCountry,
    showModal: showFavModal,
    getBrands: getBrandFavs,
    setBrands: setBrandFavs,
    isBrandFav: isBrandFav,
    toggleBrand: toggleBrandFav
  };
})();
